export const resolveYear = (
  urlYear: number | null,
  years: number[],
): number | null => {
  if (years.length === 0) return null;
  if (urlYear !== null && years.includes(urlYear)) return urlYear;
  return years[0];
};
